import React from 'react';

interface PulseContentFooterProps {
  currentStartDate: Date;
  currentEndDate: Date;
}

const PulseContentFooter: React.FC<PulseContentFooterProps> = ({ currentStartDate, currentEndDate }) => {
  const formatDate = (date: Date) => {
    return date.toLocaleDateString(undefined, {
      // timeZone: 'UTC',
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    });
  };

  return (
    <div className="pulse-content-footer">
      <h4>Legend and Notes</h4>
      <ul>
        <li>Significant changes in counts are highlighted</li>
        <li>All dates and times are in UTC format</li>
        <li>Data shown for {formatDate(currentStartDate)} to {formatDate(currentEndDate)}</li>
      </ul>
    </div>
  );
};

export default PulseContentFooter;